<template>
  <b-container>
    <h4>Visualizações BI</h4>
    <div class="form-group" v-for="row in model.powerBIViews" :key="row.powerBIViewId">
      <base-checkbox v-model="row.active">{{row.powerBIViewName}}</base-checkbox>
    </div>

    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "ProfilePowerBiViews",
  props: {
    model: Object,
    modelstate: Array,
  },
  watch: {
    id() {
      this.$forceUpdate();
    }
  }
  // data() {
  //   return {
  //     optionsBoolean: [
  //       { value: true, text: "Sim" },
  //       { value: false, text: "Não" },
  //     ],
  //     userReleases: {
  //       bi: false,
  //     },
  //   };
  // },
  // created() {
  //   this.$apiScheduler.get("/profileUser/getCompanyReleases").then((response) => {
  //     this.userReleases = response.data;
  //   });
  // },
  // computed: {
  //   hasReleaseBI() {
  //     if (this.userReleases) {
  //       return this.userReleases.bi;
  //     }
  //     return false;
  //   },
  // },
};
</script>
